export const USER_REGISTER = "user/register";
export const USER_LOGIN_LOADING = "user/login/loading";
export const USER_LOGIN_SUCCESS = "user/login/success";
export const USER_LOGIN_FAILED = "user/login/failed";
export const USER_LOGOUT = "user/logout";
